import { useEffect, useState } from 'react'
import { Outlet, useLocation } from 'react-router-dom'
import { Sidebar } from '@/components/Sidebar'
import { TopBar } from '@/components/TopBar'
import { SearchDialog } from '@/components/SearchDialog'

function scrollMainToTop() {
  const area = document.querySelector('.content-area') as HTMLElement | null
  if (area) area.scrollTop = 0
  // Also reset window / document in case the scroll container is the viewport
  window.scrollTo(0, 0)
  document.documentElement.scrollTop = 0
  document.body.scrollTop = 0
  const mainCol = document.querySelector('.main-column') as HTMLElement | null
  if (mainCol) mainCol.scrollTop = 0
}

export function AppShell() {
  const [drawer, setDrawer] = useState(false)
  const [searchOpen, setSearchOpen] = useState(false)
  const location = useLocation()

  useEffect(() => {
    setDrawer(false)
  }, [location.pathname])

  // Scroll to top only on real route/page changes (pathname).
  // Do NOT reset scroll when only search params change (e.g. ?mode=attack|defense
  // from AttackDefenseToggle, review/editor flags, explore filters) — those are
  // in-page state and must preserve scroll / sticky dock position.
  // With HashRouter (prod), useLocation().pathname is still the in-hash path.
  useEffect(() => {
    scrollMainToTop()
  }, [location.pathname])

  useEffect(() => {
    function onKey(e: KeyboardEvent) {
      if ((e.ctrlKey || e.metaKey) && e.key.toLowerCase() === 'k') {
        e.preventDefault()
        setSearchOpen(true)
      }
    }
    window.addEventListener('keydown', onKey)
    return () => window.removeEventListener('keydown', onKey)
  }, [])

  return (
    <div className={`app-shell${drawer ? ' mobile-drawer-open' : ''}`}>
      <div className="sidebar-overlay" onClick={() => setDrawer(false)} />
      <Sidebar onSearchClick={() => setSearchOpen(true)} onNavigate={() => setDrawer(false)} />
      <div className="main-column">
        <TopBar onMenu={() => setDrawer((v) => !v)} onSearch={() => setSearchOpen(true)} />
        <main className="content-area">
          <Outlet />
        </main>
      </div>
      <SearchDialog open={searchOpen} onClose={() => setSearchOpen(false)} />
    </div>
  )
}